<template>
	<Layout>
		<div class="wrap">
			<b class="clf">{{ newsData.boardClf }}</b>
			<small class="date">{{
				newsData.date
			}}</small>
			<h3>{{ newsData.title }}</h3>
			<img
				:src="resolveUrl(newsData.image)"
				alt="이미지"
			/>
			<p v-html="newsData.content"></p>
		</div>
		<!-- 주요 소식 더보기 -->
		<div class="show-more">
			<h4>주요 소식 더보기</h4>
			<div class="card">
				<div
					class="news"
					v-for="item in moreNews"
					:key="item.i"
					@click="$utils.newsClick(item.newsSn)"
				>
					<div class="img-wrap" v-if="item.image">
						<img
							:src="resolveUrl(item.image)"
							alt="뉴스이미지"
						/>
					</div>
					<div>
						<h4>{{ item.title }}</h4>
						<b>{{ item.boardClf }}</b>
						<span>{{ item.date }}</span>
					</div>
				</div>
			</div>
			<DashBtn
				:text="'목록보기'"
				@onClick="$router.push('/news')"
				class="list-btn"
			>
			</DashBtn>
		</div>
	</Layout>
</template>

<script >
import { onBeforeMount, ref } from 'vue';
import json from '../json/news.json';
import news3 from '../json/news3.json';
import { useRoute, useRouter } from 'vue-router';
import Layout from '@/components/Layout.vue';
import { getHashTime } from '@/global/utils';
export default {
	components: { Layout },
	setup() {
		const newsData = ref();
		const route = useRoute();
		const router = useRouter();
		const moreNews = ref();
		function resolveUrl(path) {
			let images = require.context(
				'@/assets/images/news/',
				false,
				/\.(png|jpg|webp)$/
			);
			return images('./' + path);
		}


		onBeforeMount(() => {
			// newsData.value =
			// 	json[
			// 		route.query.newsSn as unknown as number
			// 	];

			newsData.value = json.find(
				(item) =>
					item.newsSn ==
					(route.query
						.newsSn)
			);

			moreNews.value = news3.filter(
				(item) =>
					item.newsSn !=
					(route.query
						.newsSn)
			);

		moreNews.value =	moreNews.value.slice(0, 2);
		});

		return {
			newsData,
			resolveUrl,
			moreNews,
		};
	},
};
</script>

<style lang="scss">
.wrap {
	p {
		small {
			@include BodyS($gray5);
		}
	}
}
</style>

<style lang="scss" scoped>
.wrap {
	width: 100%;
	margin: 140px auto 120px;
	max-width: 1080px;
	text-align: center;
	.clf {
		@include BodyMB($brandL1);
		margin-right: 10px;
	}
	.date {
		@include BodyM($gray5);
	}
	h3 {
		padding: 14px 0 48px;
		margin-bottom: 48px;
		@include D3();
		display: block;
		border-bottom: 1px solid #e7e7ef;
	}
	img {
		width: 100%;
		margin-bottom: 24px;
	}
	p {
		text-align: left;
		@include BodyM();
	}
}
.show-more {
	background: $gray1;
	padding: 70px 0 120px;
	text-align: center;
	& > h4 {
		@include D4();
		margin-bottom: 50px;
	}
	.card {
		display: flex;
		justify-content: center;
		margin-bottom: 60px;
		.news {
			text-align: left;
			border-radius: 14px;
			box-shadow: $cardShadowOff;
			transition: all 0.5s;
			background: $gray0;
			overflow: hidden;
			padding-bottom: 20px;
			width: 416px;
			cursor: pointer;
			&:first-child {
				margin-right: 16px;
			}
			.img-wrap {
				width: 100%;
				height: 304px;
				img {
					width: 100%;
					height: 100%;
					object-fit: cover;
				}
			}
			h4 {
				@include BodyLB($gray7);
				margin: 20px 16px 8px;
				// height: 56px;
				@include textEllipsis();
			}
			b {
				@include BodySB($brandD1);
				margin: 0 12px 0 16px;
			}
			span {
				@include BodyS($gray5);
			}

			&:hover,
			&:active {
				box-shadow: $cardShadowOn;
				transform: translate(0, -20px);
			}
		}
	}
	.list-btn {
		margin: 0 auto;
	}
}
// 태블릿
@media screen and (max-width: $tabletW) {
	.wrap {
		max-width: 660px;
		h3 {
			padding: 10px 0 40px;
			margin-bottom: 39px;
			@include T3();
		}
	}
	.show-more {
		padding: 60px 0 80px;
		& > h4 {
			@include T4();
			margin-bottom: 40px 0 80px;
		}
		.card {
			.news {
				width: 320px;
			}
		}
	}
}
// 모바일
@media screen and (max-width: $mobileW) {
	.wrap {
		margin: 60px auto 80px;
		padding: 0 20px;
		.clf {
			@include BodySB($brandL1);
		}
		.date {
			@include BodyS($gray5);
		}

		h3 {
			padding: 6px 0 24px;
			margin-bottom: 17px;
			@include M3();
		}
		p {
			@include BodyS();
		}
	}
	.show-more {
		padding: 40px 0;
		& > h4 {
			@include M4();
			margin-bottom: 30px;
		}
		.card {
			flex-direction: column;
			padding: 0 20px;
			margin-bottom: 40px;
			.news {
				width: 100%;
				display: flex;
				padding-bottom: 0;

				cursor: pointer;
				.img-wrap {
					height: 104px;
					width: 104px;
					min-width: 104px;
				}

				h4 {
					@include BodyMB($gray7);
					margin: 14px 16px 6px;
					height: 50px;
				}
				b {
					margin: 0 12px 0 16px;
				}
				&:first-child {
					margin: 0 0 20px 0;
				}
			}
		}
	}
}
</style>
